  (function() {
    const observer = new MutationObserver(function() {
      const billingCheckbox = document.querySelector('#billing-checkbox:not([data-b2b-default-unchecked])');
      
      if (billingCheckbox) {
        billingCheckbox.setAttribute('data-b2b-default-unchecked', 'true');
        
        if (billingCheckbox.checked) {
          billingCheckbox.checked = false;
          billingCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();